import type * as ApolloReactHooks from "@apollo/client";
import {
  type ProjectsSimpleQuery,
  type ProjectsSimpleQueryVariables,
  useProjectsSimpleQuery,
} from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";

type TOnCompleted = ApolloReactHooks.QueryHookOptions<
  ProjectsSimpleQuery,
  ProjectsSimpleQueryVariables
>["onCompleted"];

export const useFetchProjectsSimple = (arg: {
  brandId: string;
  projectId?: string;
  my_projects?: boolean;
  withArchived?: boolean;
  onCompleted: TOnCompleted;
}): boolean => {
  const { loading } = useProjectsSimpleQuery({
    variables: {
      brandId: arg.brandId,
      orIdIn: arg.projectId ? [arg.projectId] : undefined,
      my_projects: arg.my_projects ?? false,
      withArchived: arg.withArchived ?? false,
    },
    context: {
      fetchOptions: {
        signal: null,
      },
    },
    skip: !arg.brandId,
    onCompleted: arg.onCompleted,
    ...onError(),
  });

  return loading;
};
